import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import Select from "@irati/ui/src/FormItem/Select"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"

import {SURVEY_STATUS_OPTIONS, SURVEY_STATUSES} from "@irati/insights/constants/survey"

const PROPERTY = "status"

export const schema = Validation.mixed().oneOf(SURVEY_STATUSES)

const Status = ({survey, onChange, label, required, ...props}) => {
  const hasId = get(survey, "id")
  return (
    <span>
      {hasId && (
        <Select
          name={PROPERTY}
          isClearable={false}
          value={get(survey, PROPERTY)}
          options={SURVEY_STATUS_OPTIONS}
          onChange={(value) => onChange(survey, PROPERTY, value)}
          label={`${label}${required ? "*" : ""}`}
          {...props}
          id={id(PROPERTY, props)} />
      )}
    </span>
  )
}

Status.propTypes = {
  required: PropTypes.bool,
  survey: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  validation: PropTypes.object
}

Status.defaultProps = {
  required: true,
  label: "Status",
  validation: schema
}

export default Status
